<!-- 培训查询 -->
<template>
    <div class="page-form" >
        <PageBack :title="title" />
        <div class="detail-wrap">  
            <el-form :model="searchForm" ref="searchForm"  label-width="100px" :inline="true"> 
                <!-- <el-form-item label="时间" prop="dateRange">
                    <el-date-picker
                        v-model="searchForm.dateRange"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="selectDate"
                        />
                </el-form-item>  -->
                <el-form-item label="培训状态" prop="status">
                    <el-select v-model="searchForm.status" >
                        <el-option 
                            v-for="item in statusOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchQuery('searchForm')">查询</el-button>
                    <!-- <el-button @click="resetForm('searchForm')">重置</el-button> -->
                </el-form-item>          
            </el-form>
            <el-table border :data="tableData" style="width: 100%;" v-loading="loading">
                <el-table-column  prop="title"  label="培训主题"  />
                <el-table-column  prop="fee"   label="培训费用(元)" width="150"/>
                <el-table-column  prop="status"  label="状态" width="150">
                    <template  slot-scope="scope">
                        <el-tag :type="scope.row.status==='完成'?'success':scope.row.status==='报名中'?'danger':'info'">{{ scope.row.status }}</el-tag>
                    </template>
                </el-table-column>               
                <el-table-column  fixed="right" label="操作"  width="350">
                    <template slot-scope="scope">
                        <el-button @click="handleLook(scope.row)" type="text" size="small">查看</el-button>
                        <el-button @click="handleUpdate(scope.row)" type="text" size="small" 
                        v-if="scope.row.limit">编辑</el-button>
                        <el-button @click="handleSetting(scope.row)" type="text" size="small" 
                            >删除</el-button>  
                        <el-button @click="handleApplyQuery(scope.row)" type="text" size="small">学员报名信息</el-button>
                        <el-button  v-if="roles==='管理员' && scope.row.status !=='赛事取消'"    
                            @click="handlePayQuery(scope.row)"  type="text" size="small">支付查询</el-button>
                    </template>                   
                </el-table-column>
            </el-table>
            <pagination
                style="text-align:right"
                v-show="total > 10"
                :total="total"
                :page.sync="queryParams.page"
                :limit.sync="queryParams.pagesize"
                @pagination="initData"
            />
        </div>
    </div>
    </template>
    
<script>
import pagination  from '@/components/Pagination'
import PageBack from '@/components/PageHeader'
export default {
    components:{
        pagination,
        PageBack
    },
    data() {
        return {
            loading: false,
            searchForm:{
                dateRange: '',
                status: null
            },
            startDate: 0,
            endDate: 0,
            queryParams: {
                page: 1,
                pagesize: 10
            },
            tableData: [],  
            amount: 0,  
            total: 0,
            statusOption:[
                {label:'报名中', value:1},
                {label:'完成', value:0},
                {label:'部分报名中', value:2},
            ]
        }   
    },
    created() {
        this.initData()
    },
    mounted() {
        
    },
    computed:{
        title(){
            return this.$route.meta.title
        },
        userId(){
            return localStorage.getItem('playerNo')
        },
        roles(){
            return localStorage.getItem('roles')
        }    
    },
    methods: {
        initData(){
            let params = {
                opcode: this.$code.TrainQuery,
                v_train_title: '',
                c_status: this.searchForm.status,
                start_date: this.startDate,
                end_date: this.endDate,
                pagesize: this.queryParams.pagesize,
                page: this.queryParams.page,
            }
            this.loading = true
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                let result = res.Data.DataTable
                this.total = res.Data.SumCount
                this.tableData = result.map(item=>{                        
                    return{
                        index: item['序号'],
                        serial: item['培训标识'],
                        userId:item['发布人'],
                        title: item['培训主题'],
                        status: item['培训状态'],
                        fee: item['培训费用'],
                        limit: this.getRoleAuditLimit(item['培训状态'],item['发布人']),
                    }
                }) 
                // console.log(result)
                this.loading = false
            }else{
                this.loading = false
                this.tableData = []
            }
        })
    },
    handleLook(row){
        this.$router.push({
            path: 'trainDetail',
            query: {
                id: row.serial
            }
        })
    },
    handleUpdate(row){
        this.$router.push({
            path: 'train',
            query: {
                id: row.serial,
                type: 'edit',
            }
        })
    }, 
    //复制一个比赛
    handleCopy(row,type){
        this.$router.push({
            path: 'train',
            query: {
                id: row.serial,
                type:type
            }
        })
    },  
    selectDate(d){
        this.startDate = d[0].replace(/\-/g,'')
        this.endDate = d[1].replace(/\-/g,'')
    },
    searchQuery() {
        this.initData()
    },
    resetForm(formName) {
        this.$refs[formName].resetFields();
        this.startDate = 0
        this.endDate = 0
    },
    handleSetting(row){
        let params = {
            opcode: this.$code.TrainDelete,
            i_serial_train: row.serial
        }
        this.$confirm('确认删除这条培训内容吗？','警告',{
            confirmButtonText: '确定',
            cancelButtonText: '取消'
        }).then(res=>{
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.$message.success("删除成功！")
                    this.initData()
                }else{
                    this.$message.error(res.Message)
                }
            })
        }).catch(err=>{
            console.log("取消")
        })
    },
    getRoleAuditLimit(status,userId){
        // if(status === '报名中'){
        //     if(this.roles === '管理员'){
        //         return true
        //     }
        // }else{
        //     return false
        // }
        if(this.roles === '管理员'){
            return true
        }else{
            return false
        }
    },
    handleApplyQuery(row){
        this.$router.push({
            path: '/trainApplyQuery',
            query: {
                id: row.serial
            }
        })
    },
    handlePayQuery(row){
        let params = {
            opcode: this.$code.AdminIntroPayment,
            i_serial_mark: row.serial,
            c_status: 0,
            start_date: 0,
            end_date: 0,                
        }
        this.$api.requestAPI(params).then(res =>{
            if(res.IsSuccess){
                // console.log(res)
                let count = res.Data.SumCount
                if(count > 1){
                    this.$router.push({
                        path: '/trainPayment',
                        query:{
                            id: row.serial
                        }                
                    })
                }else{
                    this.$message.error('暂无数据！')
                }
            }
        })
    }
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
</style>


// WEBPACK FOOTER //
// src/views/training/trainQuery.vue